import { type PropsWithChildren } from 'react';
import { useAutoSignin } from 'react-oidc-context';

import Loader from './Loader';

interface Props {}

function SingleSignOn(props: PropsWithChildren<Props>) {
  const { children } = props;
  const { isAuthenticated } = useAutoSignin();

  return isAuthenticated ? children : <Loader message="Signing in..." />;
}

export default SingleSignOn;
